import React from 'react';
import { useHistory } from 'react-router';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { TcsmContentLinkView } from '../../../../../global/components/tcsm-content-link';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { getShortFormattedDate } from '../../../../../global/helpers/date-helpers';
import { stringDateSort } from '../../../../../global/helpers/sort-helper';
import { RedesignAnnouncementBlock, TcsmNewsUpdateBlock } from '../../../../../global/models/tcsm-block-models';

// The feed only lists the most recent items; everything older lives behind the View More button.
const MAX_SIDEBAR_UPDATES = 5;
const DEFAULT_VIEW_MORE_TEXT = 'View More';

interface Props {
    newsUpdatesItems: TcsmNewsUpdateBlock[];
    latestUpdatesHeader: string;
    sidebarInfoBoxHeader: string;
    sidebarInfoBoxContent: string;
    newsUpdatesPath: string;
    viewMoreText?: string;
    announcements?: RedesignAnnouncementBlock[];
    announcementsPageUrl?: string;
}

export function PortalSidebar(props: Props) {
    const {
        newsUpdatesItems,
        newsUpdatesPath,
        latestUpdatesHeader,
        sidebarInfoBoxHeader,
        sidebarInfoBoxContent,
        viewMoreText,
        announcements,
        announcementsPageUrl,
    } = props;

    const history = useHistory();

    const useAnnouncements = !!announcementsPageUrl && !!announcements?.length;

    const latestUpdates = newsUpdatesItems?.slice().sort((a, b) => {
        return stringDateSort(a.date, b.date);
    }).slice(0, MAX_SIDEBAR_UPDATES);

    const latestAnnouncements = announcements?.slice().sort((a, b) => {
        return stringDateSort(a.date, b.date);
    }).slice(0, MAX_SIDEBAR_UPDATES);

    const renderLatestUpdate = (item: TcsmNewsUpdateBlock, index: number) => {
        return (
            <li className='dashboard-sidebar-update-list-item' key={item.title + index}>
                <span className='dashboard-sidebar-update-list-item-date'>{getShortFormattedDate(item.date)}</span>
                <TcsmContentLinkView link={item.itemLink} text={item.title} />
            </li>
        );
    };

    const renderAnnouncement = (item: RedesignAnnouncementBlock, index: number) => {
        return (
            <li className='dashboard-sidebar-update-list-item' key={item.title + index}>
                <span className='dashboard-sidebar-update-list-item-date'>{getShortFormattedDate(item.date)}</span>
                <a href={`${announcementsPageUrl}#announcement-${item.announcementId}`}>{item.title}</a>
            </li>
        );
    };

    const onViewMoreClick = () => {
        if (useAnnouncements) {
            window.location.assign(announcementsPageUrl);
            return;
        }

        history.push(newsUpdatesPath);
    };


    return (
        <>
            <SideBarContent>
                <div className='sidebar'>
                    {
                        (sidebarInfoBoxHeader || sidebarInfoBoxContent) &&
                        <div className='sidebar-section'>
                            <ContentSpacer>
                                <h2>{sidebarInfoBoxHeader}</h2>
                            </ContentSpacer>
                            <WysiwygWithReactLink content={sidebarInfoBoxContent} />
                        </div>
                    }
                    <div className='sidebar-section'>
                        <ContentSpacer>
                            {
                                latestUpdatesHeader &&
                            <ContentSpacer>
                                <h2>{latestUpdatesHeader}</h2>
                            </ContentSpacer>
                            }
                            <ul className='dashboard-sidebar-update-list'>
                                {
                                    useAnnouncements
                                        ? latestAnnouncements?.map((item, index) => renderAnnouncement(item, index))
                                        : latestUpdates?.map((item, index) => renderLatestUpdate(item, index))
                                }
                            </ul>
                        </ContentSpacer>
                        <button className='btn-secondary' type='button' onClick={onViewMoreClick}>{viewMoreText || DEFAULT_VIEW_MORE_TEXT}</button>
                    </div>

                </div>
            </SideBarContent>
        </>
    );
}

PortalSidebar.defaultProps = {
    viewMoreText: '',
    announcements: [],
    announcementsPageUrl: '',
};
